<span class="upgrade-plus">
    <slot>
        <img alt="lock" class="lock" src="/assets/tswp-core-ui-implementation/icons/lock.svg" />
    </slot>
</span>
